var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrowth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "growth 1",
    clipPath: "url(#clip0_220_3494)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 649",
    cx: 19.175,
    cy: 21.2248,
    r: 15.675,
    fill: "url(#paint0_linear_220_3494)",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.246 36.5616L13.2455 36.5614C6.51473 33.8691 2.1627 27.4427 2.1627 20.1934C2.1627 10.4712 10.0718 2.56211 19.7939 2.56211C29.5161 2.56211 37.4252 10.4712 37.4252 20.1934C37.4252 26.02 34.542 31.4771 29.7157 34.7957L13.246 36.5616ZM13.246 36.5616C13.3831 36.6155 13.5254 36.6428 13.6663 36.6428C14.1162 36.6428 14.5394 36.3738 14.716 35.9306C14.9492 35.3531 14.6683 34.6947 14.0871 34.4617L14.0871 34.4617M13.246 36.5616L14.0871 34.4617M14.0871 34.4617C8.21795 32.1112 4.4252 26.5132 4.4252 20.1934C4.4252 11.7181 11.3187 4.82461 19.7939 4.82461C28.2692 4.82461 35.1627 11.7181 35.1627 20.1934C35.1627 25.2731 32.6464 30.0377 28.4349 32.9314C27.9188 33.2847 27.7903 33.9884 28.1429 34.5038C28.4957 35.0194 29.1974 35.1531 29.7155 34.7958L14.0871 34.4617Z",
    fill: "#84E4D9",
    stroke: "#84E4D9",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.6627 14.0059C18.6627 14.6303 19.1695 15.1371 19.7939 15.1371C20.4184 15.1371 20.9252 14.6303 20.9252 14.0059V9.88086C20.9252 9.25638 20.4184 8.74961 19.7939 8.74961C19.1695 8.74961 18.6627 9.25638 18.6627 9.88086V14.0059Z",
    fill: "#EDFBF9",
    stroke: "#EDFBF9",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.6627 30.5059C18.6627 31.1303 19.1695 31.6371 19.7939 31.6371C20.4184 31.6371 20.9252 31.1303 20.9252 30.5059V26.3809C20.9252 25.7564 20.4184 25.2496 19.7939 25.2496C19.1695 25.2496 18.6627 25.7564 18.6627 26.3809V30.5059Z",
    fill: "#EDFBF9",
    stroke: "#EDFBF9",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0.276649 49.6772L0.276999 49.6777C0.49394 50.0144 0.858128 50.2 1.23144 50.2C1.44134 50.2 1.652 50.1435 1.84007 50.0234L23.7565 36.0725L31.366 43.6821C31.8073 44.1233 32.5244 44.1233 32.9656 43.6821L49.4657 27.1821C49.9069 26.7409 49.9069 26.0237 49.4657 25.5825C49.0244 25.1413 48.3073 25.1413 47.866 25.5825L32.1669 41.2817L24.7177 33.8325C24.3421 33.4569 23.7583 33.3936 23.3104 33.6786L0.622936 48.1161L0.622842 48.1161C0.0978679 48.451 -0.058185 49.1501 0.276649 49.6772Z",
    fill: "#84E4D9",
    stroke: "#84E4D9",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M47.5377 34.6309C47.5377 35.2553 48.0445 35.7621 48.6689 35.7621C49.2934 35.7621 49.8002 35.2553 49.8002 34.6309V26.3809C49.8002 25.7564 49.2934 25.2496 48.6689 25.2496H40.4189C39.7945 25.2496 39.2877 25.7564 39.2877 26.3809C39.2877 27.0053 39.7945 27.5121 40.4189 27.5121H47.5377V34.6309Z",
    fill: "#84E4D9",
    stroke: "#84E4D9",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M15.6689 27.5121H20.8252C23.1554 27.5121 25.0502 25.6173 25.0502 23.2871C25.0502 20.9569 23.1554 19.0621 20.8252 19.0621H18.7627C17.6795 19.0621 16.8002 18.1809 16.8002 17.0996C16.8002 16.0183 17.6795 15.1371 18.7627 15.1371H23.9189C24.5434 15.1371 25.0502 14.6303 25.0502 14.0059C25.0502 13.3814 24.5434 12.8746 23.9189 12.8746H18.7627C16.4325 12.8746 14.5377 14.7694 14.5377 17.0996C14.5377 19.4298 16.4325 21.3246 18.7627 21.3246H20.8252C21.9084 21.3246 22.7877 22.2058 22.7877 23.2871C22.7877 24.3684 21.9084 25.2496 20.8252 25.2496H15.6689C15.0445 25.2496 14.5377 25.7564 14.5377 26.3809C14.5377 27.0053 15.0445 27.5121 15.6689 27.5121Z",
    fill: "#EDFBF9",
    stroke: "#EDFBF9",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_220_3494",
    x1: 21.7875,
    y1: 5.5498,
    x2: 21.7875,
    y2: 41.3784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_220_3494"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.5,
    height: 49.5,
    fill: "white",
    transform: "translate(0.200195 0.599609)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowth);
export default __webpack_public_path__ + "static/media/growth.db1f36ade5f3c9058636723d240f40c9.svg";
export { ForwardRef as ReactComponent };